module.exports = __webpack_public_path__ + "img/underwriting_activity.83caaeff.png";